import InvoiceDurationCard from "~/components/Metrics/InvoiceDurationCard";
import api from "~/api";
import { useTranslation } from "react-i18next";

const InvoiceDuration = ({ siteId }: { siteId: string }) => {
  const { t } = useTranslation();
  const getInvoiceDuration = async (query: MetricsAPI.GetMetricQuery) => {
    try {
      const { data } = await api.metrics.getInvoceDurationBySite({
        siteId,
        ...query,
      });
      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <InvoiceDurationCard
      title={`${t("title.invoiceDurationBy")} ${t("text.site")}: ${siteId}`}
      onUpdate={getInvoiceDuration}
    />
  );
};

export default InvoiceDuration;
